import { osWindowReducer, type OsWindowAction, type OsWindowReducerState } from "./osWindowReducer";

export type OsWindowStore = {
  getState: () => OsWindowReducerState;
  dispatch: (action: OsWindowAction) => void;
  subscribe: (listener: () => void) => () => void;
};

export function createOsWindowStore(
  initialState: OsWindowReducerState,
): OsWindowStore {
  let state = initialState;
  const listeners = new Set<() => void>();

  return {
    getState: () => state,
    dispatch: (action) => {
      const next = osWindowReducer(state, action);
      if (next === state) {
        return;
      }
      state = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
